import Button from "@/components/button";
import { Heading, Paragraph } from "@digdir/designsystemet-react";

const Styleguide = () => {
	return (
		<div className="px-4 py-6 bg-tinted" data-color="neutral">
			<div className="container max-w-content mx-auto">
				<Heading level={1} data-size="xl">
					Komponenter
				</Heading>
				<hr />
				<div className="flex flex-col gap-2 my-4">
					<Heading level={2} data-size="sm">
						Typografi
					</Heading>
					<div className="flex flex-col px-4 py-2 bg-default">
						<Heading data-size="2xl">Heading 2xl</Heading>
						<Heading data-size="xl">Heading xl</Heading>
						<Heading data-size="lg">Heading lg</Heading>
						<Heading data-size="md">Heading md</Heading>

						<Heading data-size="sm">Heading sm</Heading>

						<Heading data-size="xs">Heading xs</Heading>

						<Heading data-size="2xs">Heading 2xs</Heading>
					</div>
					<div className="flex flex-col px-4 py-2 bg-default">
						<Paragraph data-size="xl">Body xl</Paragraph>
						<Paragraph data-size="lg">Body lg</Paragraph>
						<Paragraph data-size="md">Body md</Paragraph>
						<Paragraph data-size="sm">Body sm</Paragraph>
						<Paragraph data-size="xs">Body xs</Paragraph>
					</div>
					<div className="flex flex-col px-4 py-3 bg-default">
						<Paragraph data-size="sm" variant="short" className="mb-6">
							Body sm, short. Denne tjenesten kan du bruke for å melde
							opplysninger til Enhetsregisteret, Foretaksregisteret,
							Frivillighetsregisteret, NAV Aa-registeret, Virksomhets- og
							foretaksregisteret hos SSB, Stiftelsesregisteret og
							Skattedirektoratets register over upersonlige skattytere.
						</Paragraph>

						<Paragraph data-size="sm" variant="long" className="mb-6">
							Body sm, long. Denne tjenesten kan du bruke for å melde
							opplysninger til Enhetsregisteret, Foretaksregisteret,
							Frivillighetsregisteret, NAV Aa-registeret, Virksomhets- og
							foretaksregisteret hos SSB, Stiftelsesregisteret og
							Skattedirektoratets register over upersonlige skattytere.
						</Paragraph>
					</div>
				</div>
				<div className="flex flex-col gap-2 my-4">
					<Heading level={2} data-size="sm">
						Buttons
					</Heading>

					<div className="flex flex-col gap-2 px-4 py-2 bg-default">
						<Heading level={3} data-size="2xs">
							Primary
						</Heading>
						<div className="flex flex-wrap gap-2">
							<Button buttonText="Main" />
							<Button buttonText="Neutral" color="neutral" />
							<Button buttonText="Danger" color="danger" />
						</div>
					</div>
					<div className="flex flex-col gap-2 px-4 py-2 bg-default">
						<Heading level={3} data-size="2xs">
							Secondary
						</Heading>
						<div className="flex flex-wrap gap-2">
							<Button buttonText="Main" variant="secondary" />
							<Button
								buttonText="Neutral"
								variant="secondary"
								color="neutral"
							/>
							<Button buttonText="Danger" variant="secondary" color="danger" />
						</div>
					</div>
					<div className="flex flex-col gap-2 px-4 py-2 bg-default">
						<Heading level={3} data-size="2xs">
							Tertiary
						</Heading>
						<div className="flex flex-wrap gap-2">
							<Button buttonText="Main" variant="tertiary" />
							<Button buttonText="Neutral" variant="tertiary" color="neutral" />
							<Button buttonText="Danger" variant="tertiary" color="danger" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Styleguide;
